import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { partnersService } from "../services/partner.service";
import { IOption } from "Dashboard/domain/IOption";

const MunicipalitySelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const projects = await partnersService.getAllMunicipalities();
      const op = projects.map((municipality) => {
        return {
          label: municipality.name,
          value: municipality.municipalityId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getValue = () => {
    if (value) {
      return value;
    }
    return valueLocal;
  };

  const setValueFunction = (option: IOption | undefined) => {
    if (setValue) {
      setValue(option);
    }
    setValueLocal(option);
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      isClearable
      menuPosition="fixed"
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error, width: props.width }}
    />
  );
});

export default MunicipalitySelect;
